/* eslint-disable no-console */

import { register } from "register-service-worker";

// Se habilita el registro únicamente en producción; en desarrollo se limpia el SW para evitar congelamiento de cache
if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");

      // Purgar cachés antiguos de imágenes e iconos para forzar descarga inmediata de los nuevos de Vaquiano (v3)
      if (typeof window !== "undefined" && "caches" in window) {
        caches.keys().then((names) => {
          for (const name of names) {
            if (name === "images" || name === "images-v2") {
              caches.delete(name);
            }
          }
        });
      }

      // ============================================================
      // CHECK PERIÓDICO: Buscar actualizaciones cada 30 minutos.
      // Importante para zonas rurales donde la conexión va y viene.
      // ============================================================
      setInterval(() => {
        registration.update();
      }, 30 * 60 * 1000);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; please refresh.");

      // ============================================================
      // AUTO-UPDATE: Notificar al usuario con un banner discreto
      // para que recargue y obtenga la última versión.
      // ============================================================
      const updateBanner = document.createElement("div");
      updateBanner.id = "sw-update-banner";
      updateBanner.innerHTML = `
          <div style="
            position: fixed; bottom: 1rem; left: 50%; transform: translateX(-50%);
            background: #1e293b; color: #fff; padding: 0.75rem 1.25rem;
            border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.25);
            display: flex; align-items: center; gap: 0.75rem; z-index: 9999;
            font-family: sans-serif; font-size: 0.9rem;
          ">
            <span>🔄 Nueva versión disponible</span>
            <button id="sw-update-btn" style="
              background: #22c55e; color: #fff; border: none; padding: 0.4rem 1rem;
              border-radius: 8px; font-weight: 600; cursor: pointer; font-size: 0.85rem;
            ">Actualizar</button>
          </div>
        `;
      document.body.appendChild(updateBanner);

      document.getElementById("sw-update-btn").addEventListener("click", () => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        window.location.reload();
      });
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );

      // ============================================================
      // OFFLINE INDICATOR: Mostrar indicador visual discreto
      // ============================================================
      const offlineBanner = document.createElement("div");
      offlineBanner.id = "offline-banner";
      offlineBanner.innerHTML = `
          <div style="
            position: fixed; top: 70px; left: 50%; transform: translateX(-50%);
            background: #f59e0b; color: #1e293b; padding: 0.4rem 1rem;
            border-radius: 20px; font-size: 0.8rem; font-weight: 600;
            box-shadow: 0 2px 10px rgba(0,0,0,0.15); z-index: 9998;
            font-family: sans-serif;
          ">
            ⚠️ Sin conexión — Modo offline
          </div>
        `;
      document.body.appendChild(offlineBanner);

      // Quitar banner al recuperar conexión
      window.addEventListener(
        "online",
        () => {
          const banner = document.getElementById("offline-banner");
          if (banner) banner.remove();
        },
        { once: true }
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
} else {
  // En desarrollo: desregistrar cualquier Service Worker activo y purgar CacheStorage
  if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister().then((unregistered) => {
          if (unregistered) {
            console.log(
              "Dev mode: Service Worker desregistrado para permitir recargas directas."
            );
          }
        });
      }
    });
  }
  if (typeof window !== "undefined" && "caches" in window) {
    caches.keys().then((keys) => {
      for (const key of keys) {
        caches.delete(key);
      }
    });
  }
}

// ============================================================
// ONLINE/OFFLINE LISTENERS: Re-mostrar banner si pierde conexión
// después del registro del SW.
// ============================================================
window.addEventListener("offline", () => {
  if (!document.getElementById("offline-banner")) {
    const offlineBanner = document.createElement("div");
    offlineBanner.id = "offline-banner";
    offlineBanner.innerHTML = `
        <div style="
          position: fixed; top: 70px; left: 50%; transform: translateX(-50%);
          background: #f59e0b; color: #1e293b; padding: 0.4rem 1rem;
          border-radius: 20px; font-size: 0.8rem; font-weight: 600;
          box-shadow: 0 2px 10px rgba(0,0,0,0.15); z-index: 9998;
          font-family: sans-serif;
        ">
          ⚠️ Sin conexión — Modo offline
        </div>
      `;
    document.body.appendChild(offlineBanner);
  }
});

window.addEventListener("online", () => {
  const banner = document.getElementById("offline-banner");
  if (banner) banner.remove();
});
